﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
export * from './jwt.interceptor';
export * from './fake-backend';
